var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78125 12.0312V25.4688H16.7188V12.0312H5.78125ZM18.2812 25.4587L24.2188 25.383V18.2812H18.2812V25.4587ZM18.2812 16.7188V11.4904C18.2812 10.9262 17.8238 10.4688 17.2596 10.4688H5.24039C4.67615 10.4688 4.21875 10.9262 4.21875 11.4904V26.25C4.21875 26.6815 4.56853 27.0312 5 27.0312H17.5L25.01 26.9355C25.4375 26.9301 25.7812 26.5819 25.7812 26.1543V17.7404C25.7812 17.1762 25.3238 16.7188 24.7596 16.7188H18.2812Z",
    fill: "#0173C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22939 3.62156C4.29217 3.24485 4.6181 2.96875 5.00001 2.96875H17.5C17.8819 2.96875 18.2078 3.24485 18.2706 3.62156L19.5206 11.1216C19.5584 11.3481 19.4946 11.5798 19.3461 11.755C19.1977 11.9302 18.9797 12.0312 18.75 12.0312H3.75001C3.52036 12.0312 3.30234 11.9302 3.1539 11.755C3.00546 11.5798 2.94163 11.3481 2.97939 11.1216L4.22939 3.62156ZM5.66182 4.53125L4.67224 10.4688H17.8278L16.8382 4.53125H5.66182Z",
    fill: "#0173C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96875 18.75C7.96875 18.3185 8.31853 17.9688 8.75 17.9688H13.75C14.1815 17.9688 14.5312 18.3185 14.5312 18.75V26.25C14.5312 26.6815 14.1815 27.0312 13.75 27.0312H8.75C8.31853 27.0312 7.96875 26.6815 7.96875 26.25V18.75ZM9.53125 19.5312V25.4688H12.9688V19.5312H9.53125Z",
    fill: "#0173C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34375 15C7.34375 14.5685 7.69353 14.2188 8.125 14.2188L14.375 14.2187C14.8065 14.2187 15.1562 14.5685 15.1562 15C15.1562 15.4315 14.8065 15.7813 14.375 15.7813L8.125 15.7813C7.69353 15.7813 7.34375 15.4315 7.34375 15Z",
    fill: "#0173C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9688 26.2498C2.96891 25.8183 3.31877 25.4687 3.75024 25.4688L26.2504 25.4744C26.6819 25.4745 27.0316 25.8244 27.0315 26.2558C27.0314 26.6873 26.6815 27.037 26.2501 27.0369L3.74985 27.0313C3.31838 27.0312 2.96869 26.6813 2.9688 26.2498Z",
    fill: "#0173C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5312 21.25C19.5312 20.8185 19.881 20.4688 20.3125 20.4688H22.1875C22.619 20.4688 22.9688 20.8185 22.9688 21.25C22.9688 21.6815 22.619 22.0312 22.1875 22.0312H20.3125C19.881 22.0312 19.5312 21.6815 19.5312 21.25Z",
    fill: "#0173C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7188 13.75C16.7188 13.3185 17.0685 12.9688 17.5 12.9688H25C25.3363 12.9688 25.6348 13.1839 25.7412 13.5029L26.9912 17.2529C27.0706 17.4912 27.0306 17.7531 26.8838 17.9568C26.7369 18.1605 26.5011 18.2812 26.25 18.2812H17.5C17.0685 18.2812 16.7188 17.9315 16.7188 17.5V13.75ZM18.2813 14.5312V16.7188H25.1661L24.4369 14.5312H18.2813Z",
    fill: "#0173C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondo);
export default __webpack_public_path__ + "static/media/Condo.13937d2d.svg";
export { ForwardRef as ReactComponent };